import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Note } from '../models/note.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private baseUrl = environment.notesApiUrl;

  // private baseUrl = "http://localhost:3004/api"

  constructor(private http: HttpClient) {}


  getNotesByUserJourneySectionId(
    userJourneySectionId: string
  ): Observable<any[]> {
    const url = `${this.baseUrl}/admin/notes/user-section/${userJourneySectionId}`;
    return this.http.get<Note[]>(url);
  }

  createNote(note: Partial<Note>): Observable<Note> {
    const url = `${this.baseUrl}/admin/notes`;
    return this.http
      .post<{ message: string; data: Note }>(url, note)
      .pipe(map((res) => res.data));
  }

  updateNote(noteId: string, content: string): Observable<Note> {
    const url = `${this.baseUrl}/admin/notes/${noteId}`;
    return this.http.put<Note>(url, { content });
  }

  getPopulatedNote(
    userId: string,
    noteType: string,
    format: 'html' | 'text' = 'html'
  ): Observable<string> {
    const url = `${this.baseUrl}/admin/notes/populated-template`;
    const params = { userId, noteType, format } as const;
    return this.http.get<any>(url, { params }).pipe(
      map((res) => {
        // Support both `{ message, data }` and raw string responses
        if (res == null) return '';
        if (typeof res === 'string') return res;
        if (typeof res.html === 'string') return res.html;
        if (typeof res.content === 'string') return res.content;
        return '';
      })
    );
  }

  
}
